<template>
  <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.5 11L6.5 6L1.5 1" stroke="#0B254E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
  
  <script setup></script>